<template>
  <div v-if="stageComment && show" class="margin_top_20 margin-left-10 margin-right-10 margin-bottom-20">
    <weex-text class="font-size-sm-base font-weight-bold">Comments from Verification Team</weex-text>
    <weex-text class="font-size-sm-base font-weight-bold" style="color: red">{{ stageComment }}</weex-text>
  </div>
</template>

<script>
  import LoanScopeDataHolder from "@/data/model/LoanScopeDataHolder";

  export default {
    name: "ErrorAlertItem",
    components: {},
    props: {
      show: {
        type: Boolean,
        default: true
      }
    },

    computed: {
      stageComment() {
        return LoanScopeDataHolder.getCurrentLoanTask()
          ? LoanScopeDataHolder.getCurrentLoanTask().comments : ""
      }
    }
  }
</script>


<style
  scoped
  src="../../assets/style/base.css"></style>
